export enum BrandingRoutes {
  root = 'branding',
  main = '',
  ux = 'ux-configuration',
  look_feel = 'look-feel',
  vcard = 'vcard',
}
